<template>
    <app-layout>
<!--        <template #header>-->
<!--            <nav role="navigation">-->
<!--                <div class="container mx-auto flex flex-wrap items-center md:flex-no-wrap">-->
<!--                    <div class="w-full md:w-auto md:flex-grow md:flex md:items-center">-->
<!--                        <ul class="flex flex-col border-t md:flex-row md:items-center  md:border-0">-->
<!--                            <li>-->
<!--                                <div-->
<!--                                    class="block px-4 lg:px-4 bg-white hover:bg-blue-100 text-black border-2 mt-2 mr-2 py-2 px-4  font-bold rounded-full"-->
<!--                                    title="Active Link">-->
<!--                                    <inertia-link :href="route('dashboard')">-->
<!--                                        Planning Poker Settings-->
<!--                                    </inertia-link>-->
<!--                                </div>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <div-->
<!--                                    class="block px-4 lg:px-4 bg-white hover:bg-blue-100 text-black border-2 mt-2 mr-2 py-2 px-4 font-bold rounded-full"-->
<!--                                    title="Active Link">-->
<!--                                    <inertia-link :href="route('dashboard')">-->
<!--                                        Stand-Up Settings-->
<!--                                    </inertia-link>-->
<!--                                </div>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <div-->
<!--                                    class="block px-4 lg:px-4 bg-white hover:bg-blue-100 text-black  border-2 mt-2 mr-2 py-2 px-4  font-bold rounded-full"-->
<!--                                    title="Active Link">-->
<!--                                    <inertia-link :href="route('dashboard')">-->
<!--                                        Retrospective Settings-->
<!--                                    </inertia-link>-->
<!--                                </div>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <div-->
<!--                                    class="block px-4 lg:px-4 bg-white hover:bg-blue-100 text-red-500  border-2 mt-2 mr-2 py-2 px-4  font-bold rounded-full"-->
<!--                                    title="Active Link">-->
<!--                                    <inertia-link :href="route('dashboard')">-->
<!--                                        Uninstall AgileBot-->
<!--                                    </inertia-link>-->
<!--                                </div>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </nav>-->

<!--        </template>-->
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="w-full">

                    <agile-bot-home-page></agile-bot-home-page>
                </div>
            </div>
        </div>


    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import AddToSlackButton from "@/Components/SocialButton/AddToSlackButton";
import AgileBotHomePage from "@/Pages/SlackBot/AgileBotHomePage";

export default {
    props: [],
    data() {
        return {}
    },
    mounted() {

    },
    methods: {
        goToGame() {
            this.$inertia.visit(route('planning-poker-id', {id: 2}));
        }
    },
    components: {
        AgileBotHomePage,
        AddToSlackButton,
        AppLayout
    },
}
</script>
